import { useGitFilePreview } from '@/react/portainer/gitops/queries/useGitFilePreview';

/**
 * Base parameters for Git Helm chart operations
 */
export type GitHelmChartBaseParams = {
  /** The Git repository URL */
  repository: string;
  /** The path to the chart within the repository */
  chartPath: string;
  /** The Git reference (branch/tag) */
  reference?: string;
  /** The username for Git authentication */
  username?: string;
  /** The password for Git authentication */
  password?: string;
  /** The authorization type for Git authentication */
  authorizationType?: number;
  /** The Git credential ID to use */
  gitCredentialID?: number;
  /** Whether to skip TLS verification */
  tlsSkipVerify?: boolean;
};

type GitHelmChartParams = GitHelmChartBaseParams & {
  /** The command to run (chart, values, readme) */
  command?: 'chart' | 'values' | 'readme';
};

const fileMap = {
  values: 'values.yaml',
  chart: 'Chart.yaml',
  readme: 'README.md',
} as const;

export function useGitHelmChartValues(
  params: GitHelmChartParams,
  enabled = true
) {
  const command = params.command || 'values';
  const targetFile = params.chartPath
    ? `${params.chartPath}/${fileMap[command]}`
    : fileMap[command];

  return useGitFilePreview(
    {
      repository: params.repository,
      targetFile,
      reference: params.reference || 'refs/heads/main',
      username: params.username,
      password: params.password,
      authorizationType: params.authorizationType,
      gitCredentialId: params.gitCredentialID,
      tlsSkipVerify: params.tlsSkipVerify,
    },
    {
      enabled: !!params.repository && !!params.command && enabled,
      select: (data) => ({ values: data }),
    }
  );
}
